export default {
    computed: {
        fastTrackExtras: function() {
            return this.extras.filter(function(extra) {
                return extra.category == 'Fast Track';
            });
        },
        otherExtras: function() {
            return this.extras.filter(function(extra) {
                return extra.category != 'Fast Track' && extra.category != 'Insurance';
            });
        },
    },

    created() {
        new Promise(resolve => setTimeout(resolve, 2000)).then(response => {
            this.$store.dispatch('fetchExtras', this.$route.params.id).catch(error => {
                this.$store.dispatch('createError', error);
            });
        });
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/Options.js